const _tight = "-0.04em"
const _snug = "-0.02em"
const _normal = 0
const _relaxed = "0.02em"
const _wide = "0.08em"
const _loose = "0.16em"
const config = { "tight": _tight, "snug": _snug, "normal": _normal, "relaxed": _relaxed, "wide": _wide, "loose": _loose,  }
export { config as default, _tight, _snug, _normal, _relaxed, _wide, _loose }